import React, {memo} from 'react';

import {SearchDestinationSummaryInputField} from '../SearchDestinationSummaryInputField/SearchDestinationSummaryInputField';
import {SearchSubmitSummaryButtonField} from '../SearchSubmitSummaryButtonField/SearchSubmitSummaryButtonField';

import {useComponent} from './hooks/useComponent';

import './SearchSummaryFields.less';

import '../SearchSummaryField/SearchSummaryField.less';
import '../SearchSummaryInputField/SearchSummaryInputField.less';
import '../SearchSummaryButtonField/SearchSummaryButtonField.less';

const SearchSummaryFields = memo(function SearchSummaryFields() {
    const {
        className
    } = useComponent();

    return (
        <div className={className}>
            <SearchDestinationSummaryInputField/>
            <SearchSubmitSummaryButtonField/>
        </div>
    );
});

SearchSummaryFields.whyDidYouRender = true;

export {SearchSummaryFields};
